import { useState, useEffect } from "react";
import { X, Zap, Clock } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";
import { useLanguage } from "@/contexts/LanguageContext";

const OfferBanner = () => {
  const navigate = useNavigate();
  const { t } = useLanguage();
  const [isVisible, setIsVisible] = useState(true);
  const [timeLeft, setTimeLeft] = useState({
    hours: 23,
    minutes: 59,
    seconds: 59,
  });

  useEffect(() => {
    const dismissed = localStorage.getItem("offerBannerDismissed");
    if (dismissed) {
      const dismissedTime = new Date(dismissed).getTime();
      const now = new Date().getTime();
      if (now - dismissedTime < 24 * 60 * 60 * 1000) {
        setIsVisible(false);
      }
    }
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      setTimeLeft((prev) => {
        if (prev.seconds > 0) {
          return { ...prev, seconds: prev.seconds - 1 };
        } else if (prev.minutes > 0) {
          return { ...prev, minutes: prev.minutes - 1, seconds: 59 };
        } else if (prev.hours > 0) {
          return { hours: prev.hours - 1, minutes: 59, seconds: 59 };
        }
        return { hours: 23, minutes: 59, seconds: 59 };
      });
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  const handleDismiss = () => {
    setIsVisible(false);
    localStorage.setItem("offerBannerDismissed", new Date().toISOString());
  };

  if (!isVisible) return null;

  const formatNumber = (n: number) => n.toString().padStart(2, "0");

  return (
    <div className="relative bg-gradient-to-r from-primary via-blue-600 to-primary bg-[length:200%_auto] animate-[gradient_3s_linear_infinite] text-primary-foreground">
      <div className="container mx-auto px-4 py-2.5 sm:py-3">
        <div className="flex items-center justify-center gap-2 sm:gap-4 text-center">
          <Zap className="w-4 h-4 sm:w-5 sm:h-5 flex-shrink-0 animate-pulse" />
          
          <div className="flex items-center gap-2 sm:gap-4 flex-wrap justify-center">
            <span className="text-xs sm:text-sm font-medium">
              <span className="hidden sm:inline">{t('offer.special')}</span>
              <span className="font-bold ml-1">{t('offer.discount')}</span> {t('offer.text')}
            </span>
            
            <div className="flex items-center gap-1 text-xs sm:text-sm">
              <Clock className="w-3 h-3 sm:w-4 sm:h-4" />
              <span className="font-mono font-bold">
                {formatNumber(timeLeft.hours)}:{formatNumber(timeLeft.minutes)}:{formatNumber(timeLeft.seconds)}
              </span>
            </div>
            
            <Button
              size="sm"
              variant="secondary"
              className="h-7 sm:h-8 text-xs sm:text-sm px-3 sm:px-4 bg-white/20 hover:bg-white/30 text-white border-0"
              onClick={() => navigate("/auth")}
            >
              {t('offer.cta')}
            </Button>
          </div>
          
          <button
            onClick={handleDismiss}
            className="absolute right-2 sm:right-4 top-1/2 -translate-y-1/2 p-1 hover:bg-white/10 rounded-full transition-colors"
            aria-label="Fechar banner"
          >
            <X className="w-4 h-4" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default OfferBanner;
